const ALLOWED = /^(https?:|mailto:|tel:)/i;
const BARE_HOST = /^(www\.|[\w-]+(\.[\w-]+)+)/i;

/**
 * The address a link may point to: http(s), mailto or tel. A bare host
 * (`www.example.com`, `example.com/page`) becomes https. Anything else —
 * `javascript:`, `data:`, relative paths — is refused with `undefined`.
 */
export function normalizeRichTextHref(raw: string): string | undefined {
  const value = raw.trim();
  if (!value) return undefined;
  const candidate = ALLOWED.test(value)
    ? value
    : BARE_HOST.test(value)
      ? `https://${value}`
      : undefined;
  if (!candidate) return undefined;
  try {
    const url = new URL(candidate);
    return ALLOWED.test(url.protocol) ? candidate : undefined;
  } catch {
    return undefined;
  }
}
